import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
export function Field({ label, description, hint, error, htmlFor, required, children, className = "", }) {
    const descriptionId = description ? React.useId() : undefined;
    const hintId = hint && !error ? React.useId() : undefined;
    const errorId = error ? React.useId() : undefined;
    const child = React.Children.only(children);
    const childProps = {};
    if (htmlFor) {
        childProps.id = htmlFor;
    }
    const describedBy = [descriptionId, hintId, errorId].filter(Boolean).join(" ");
    if (describedBy) {
        childProps["aria-describedby"] = describedBy;
    }
    if (error) {
        childProps["aria-invalid"] = true;
        childProps["data-invalid"] = "true";
    }
    const enhancedChild = React.isValidElement(child) ? React.cloneElement(child, childProps) : child;
    return (_jsxs("div", { className: ["flex flex-col gap-1.5", className].join(" "), children: [label ? (_jsxs("label", { htmlFor: htmlFor, className: "text-sm font-medium text-zinc-800", children: [label, required ? _jsx("span", { className: "text-red-600", children: " *" }) : null] })) : null, description ? (_jsx("p", { id: descriptionId, className: "text-sm text-zinc-500", children: description })) : null, enhancedChild, error ? (_jsx("p", { id: errorId, className: "text-sm text-red-600", role: "alert", children: error })) : hint ? (_jsx("p", { id: hintId, className: "text-xs text-zinc-400", children: hint })) : null] }));
}
